import React from "react";
import Control from "../../../../common/Controls/Control";
import useFormState from "../useFormState";
import BlockWrapper from "../../Layout/BlockWrapper";

const RCPROComment = () => {
  const { errors, actions, inputsConfig, formData } = useFormState();
  const inputState = formData.rcproCommentInputs;

  const updateRcproData = (e) => {
    const { name, value } = e.target;

    actions.updateRCPROCommentInputs({ [name]: value });
  };

  return (
    <>
      <BlockWrapper>
        <Control
          label={inputsConfig.commentaireRcpro.label}
          type="textarea"
          value={inputState.commentaireRcpro}
          change={updateRcproData}
          name="commentaireRcpro"
          error={errors}
          labelClassname="w-100"
          placeholder={""}
        />
      </BlockWrapper>
    </>
  );
};

export default RCPROComment;
